import { Options, Prop, Vue } from "vue-property-decorator";

@Options({})
export default class ContinueToManageSignatories extends Vue {


  @Prop({ default: false })
  private modalOpened!: boolean;

  mounted() {
    document.body.classList.add('modal-open');
  }

  beforeUnmount() {
    document.body.classList.remove('modal-open');
  }

  private closeModal(): void {
    this.$emit('close');
  }

  private continueClicked(): void {
    this.$emit('continue');
  }

}

